import { render, staticRenderFns } from "./PaneIcon.vue?vue&type=template&id=04a5e212"
import script from "./PaneIcon.vue?vue&type=script&lang=js"
export * from "./PaneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports